<template>
  <div class="report-page">
    <el-row class="report-main" v-if="!expRecordInfo.report">
      <is-empty :show="reports.length>0" message="暂时没有数据~">
        <div class="editor">
          <div class="report-title">
            <img src="~@/assets/imgs/ic_problem.png" alt=""> 题目
            <el-button class="sub-btn" type="success" size="mini" @click="checkReport(false)" :disabled="isStatus">
              {{ isSubmitReports ? '再次提交' : '提交' }}
            </el-button>
          </div>
          <div class="title-info">
            {{ report.title }}
          </div>
          <div class="report-title"><img src="~@/assets/imgs/ic_describe.png" alt=""> {{ `答案` }}</div>
          <div class="report-info">
            <editor ref="editor" :content="report.answer" @onchange="handleChange"/>
          </div>
        </div>
        <div class="answer-card" v-show="showCard">
          <div class="card-title">答题卡</div>
          <div
              :class="{
                  'card-number': true,
                  'number-active': index === indexQuestion
              }"
              v-for="(re, index) in reports"
              :key="index"
              @click="handleClickCard(index)"
          >
            {{ index + 1 }}
          </div>
          <div class="card-bottom" @click="showCard = false">
            <i class="el-icon-arrow-up"></i>
          </div>
        </div>
        <div class="small-card" v-show="!showCard" @click="showCard = true">
          <i class="el-icon-arrow-right"></i>
        </div>
      </is-empty>
    </el-row>
    <template v-if="expRecordInfo.report">
      <el-card v-show="showDoc">
        <el-row class="report-answer">
          <el-col :span="12">
            <i class="el-icon-s-grid"></i>
          </el-col>
          <el-col :span="12" style="text-align:right">
            <el-button class="sub-btn" type="warning" size="mini" :disabled="disStatus" @click="handSave">保存报告
            </el-button>
            <el-button
                class="sub-btn"
                type="primary"
                style="text-align:right"
                size="mini"
                :disabled="disStatus"
                @click="handSubmit">提交报告
            </el-button>
          </el-col>
          <el-col :span="6" style="text-align:right">
          </el-col>
        </el-row>
        <div>
          <fm-generate-form
              ref="generateForm"
              :data="newReports"
              :isTeacher="false"
              :disable="false"
              @image-added="imageAdded"
              :custom-config="customConfig"
          ></fm-generate-form>
        </div>
      </el-card>
    </template>
  </div>
</template>

<script>
import isEmpty from '@/components/common/is-empty'
import editor from '@/components/common/editor'
import { baseUrl, staticUrl } from "@/config/env";

import {submitReport, getMyExpReport} from '@/api/lab/experiment'
import {editReportContent, getGraded} from '@/api/lab/labexperiment2user'
import {getFamtterTimer} from '@/utils/time'
import {mapGetters} from 'vuex'
import {uploadFile} from "@/api/file";

export default {
  components: {
    isEmpty,
    editor
  },
  computed: {
    ...mapGetters(['token']),
    customConfig(){
        let obj = {
            uploadImgHooks: {
                customInsert: this.customInsert
            },
            uploadImgHeaders:{
                token: this.token
            },
            uploadImgServer: `${baseUrl}/api/file/uploadFile`
        }
        console.log(obj)
        return obj
    }
  },
  props: {
    uid: {
      type: String
    },
    isSave: {
      type: Boolean,
      default() {
        return false
      }
    },
    baseUrl: {
      type: String,
      default: ''
    },
    expRecordInfo: {
      type: Object,
      default: () => {
      }
    },
    showDoc: {
      type: Boolean,
      default() {
        return false
      }
    },
    isStatus: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  data() {
    return {
      newReports: {
        "list": [],
        "config": {
          "labelWidth": 100,
          "labelPosition": "top",
          "size": "small",
          "score": 0,
          "passScore": 0,
          "goal": 0
        }
      },
      disStatus: true,
      editData: {},
      reports: [],
      indexQuestion: 0,
      report: {
        title: '',
        answer: null
      },
      showCard: true,
      isSubmitReports: true, // 是否提交过报告,
      newPreData: {}
    }
  },
  watch: {
    isSave(n) {
      if (n) this.checkReport(true)
    },
    'expRecordInfo.status': {
      // let a = this.expRecordInfo.status == 0
      // let b = this.expRecordInfo.status == 3
      // return a || b
      deep: true,
      immediate: true,
      handler(val) {
        this.disStatus = !(val === 0 || val === 3);
      },
    }
  },
  methods: {
    customInsert(insertImg, result){
        console.log(1,insertImg, result)
        let data = [`${staticUrl}/${result.data.originalPath}`];
        JSON.stringify(data);
        insertImg(data);
    },
    imageAdded(file, Editor, cursorLocation, resetUploader) {
      // 文件上传
      uploadFile(file, `lesson/exp/user/${this.expRecordInfo.id}/report`).then(res => {
        if (res) {
          let url = res.originalPath;
          Editor.insertEmbed(cursorLocation, "image", this.$options.filters["filterUrl"](url));
          resetUploader();
        }
      })
    },
    handSave() {
      this.$refs.generateForm.getData().then(data => {
        let obj = this.$refs.generateForm.data
        let newObj = JSON.parse(JSON.stringify(obj))
        obj.list.map(item => {
          let model = item.model
          item.defaultValue = data[model]
        })
        newObj.list.map(item => {
          let model = item.model
          if (item.type == "checkbox") {
            data[model].sort()
            data[model] = data[model].filter(s => {
              return s && s.trim()
            })
            item.defaultValue = data[model].join(',')
          } else {
            item.defaultValue = data[model]
          }
        })
        let id = this.expRecordInfo.id
        let report = JSON.stringify(newObj)
        let submitTime = getFamtterTimer(+new Date())
        let params = {
          id,
          report,
          submitTime
        }
        editReportContent(params).then(() => {
          this.$message.success('操作成功!')
        })
      }).catch(() => {
      })
    },
    handSubmit() {
      this.$refs.generateForm.getData().then(data => {
        let obj = this.$refs.generateForm.data
        let newObj = JSON.parse(JSON.stringify(obj))
        obj.list.map(item => {
          let model = item.model
          item.defaultValue = data[model]
        })
        newObj.list.map(item => {
          let model = item.model
          item.goal = 0
          if (item.type === "checkbox") {
            data[model].sort()
            data[model] = data[model].filter(s => {
              return s && s.trim()
            })
            item.defaultValue = data[model].join(',')
          } else {
            item.defaultValue = data[model]
          }
        })
        let id = this.expRecordInfo.id
        let report = JSON.stringify(newObj)
        let submitTime = getFamtterTimer(+new Date())
        let params = {
          id,
          report,
          submitTime
        }
        if (this.expRecordInfo.status === 0 || this.expRecordInfo.status === 3) {
          params.status = 1
        }
        this.$confirm('提交报告后将无法修改，是否确认提交报告？', '确认信息', {
          distinguishCancelAndClose: true,
          confirmButtonText: '提交',
          cancelButtonText: '放弃提交'
        }).then(() => {
          editReportContent(params).then(() => {
            this.getGraded(params.id)
          })
        }).catch(() => {
        });
      }).catch(() => {
      })
    },
    handleChange(txt) {
      this.$set(this.report, 'answer', txt)
      this.reports[this.indexQuestion].answer = txt;
    },
    getGraded(id) {   //自动评分
      getGraded(id).then(() => {
        this.disStatus = true
        this.$message.success('操作成功!')
      }).catch(() => {
      })
    },
    handleClickCard(index) {
      let report = {
        title: '',
        answer: '',
        ...JSON.parse(JSON.stringify(this.reports[index]))
      }
      this.$nextTick(() => {
        this.indexQuestion = index
        this.report = report
        // 改变文本框的内容
        this.$refs['editor'].changeTxt(report.answer)
      })
    },
    getReports() {
      getMyExpReport(this.uid).then(res => {
        let state = true
        res.map(row => {
          if (row.answer === undefined) {
            state = false
            Object.assign(row, {
              answer: null
            })
          }
        })
        this.isSubmitReports = state
        this.reports = res;
        if (this.reports.length > 0) this.handleClickCard(0);
      })
    },
    checkReport(exit = false) {
      if (this.reports.length > 0) {
        let isAll = true
        this.reports.map(row => {
          if (row.answer == null)
            isAll = false;
        })
        if (!this.isSubmitReports) {
          if (!isAll) {
            this.$confirm('检测到您还有报告没有填写，是否确认提交报告？', '确认信息', {
              distinguishCancelAndClose: true,
              confirmButtonText: '提交',
              cancelButtonText: '放弃提交'
            }).then(() => {
              this.submitReport(exit);
            }).catch(() => {
              if (exit) {
                this.$emit('exit')
              }
            });
          } else {
            this.submitReport(exit);
          }
        } else if (exit) {
          this.$emit('exit')
        } else {
          if (!isAll) {
            this.$confirm('检测到您还有报告没有填写，是否确认提交报告？', '确认信息', {
              distinguishCancelAndClose: true,
              confirmButtonText: '提交',
              cancelButtonText: '放弃提交'
            }).then(() => {
              this.submitReport(exit);
            }).catch(() => {
              if (exit) {
                this.$emit('exit')
              }
            });
          } else {
            this.submitReport(exit);
          }
        }
      }
    },
    // 提交报告
    submitReport(exit) {
      submitReport(this.uid, this.reports).then(() => {
        this.$message.success('报告提交成功！');
        this.getReports();
        if (exit) {
          this.$emit('exit')
        }
      })
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.expRecordInfo.report) {
        let obj = JSON.parse(this.expRecordInfo.report)
        obj.list.map((item, index) => {
          if (!item.model) {
            obj.list[index].model = item.key
          }
          if (item.type == 'checkbox') {
            if (typeof (item.defaultValue) === 'string') {
              item.defaultValue = item.defaultValue.split(',')
            }
          }
          item.rules = []
        })
        this.newReports = obj
      } else {
        this.getReports();
      }
    })
  }
}
</script>

<style lang="less">
@import "~@/assets/css/exp-run-report";

.report-page {
  .label-mark {
    display: none;
  }

  .label-width-item {
    padding-right: 0;
  }

  .report-answer {
    padding: 15px 0;
  }
}
</style>
